<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('personalCompanyActivate.frdiXsProfilininAktivldirilmsi')" />
      <h4 class="mb-4">
        {{ $t('personalCompanyActivate.frdiXsProfilininAktivldirilmsi') }}
      </h4>
      <div class="row">
        <div class="col-xl-8 ">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="createCompany">
                <div class="row">
                  <div class="col-6 mb-3">
                    <label>{{ $t('personalCompanyActivate.faliyytIstiqamti') }}</label>
                    <select
                      v-model="selectedProfile"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="(v,f) in profiles"
                        :key="v"
                        :value="f"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="mb-3">
                  <label>{{ $t('companySearch.faliyytSahlri') }}</label>
                  <div class="mt-1">
                    <button
                      v-b-modal.modal-sector-selection
                      type="button"
                      class="btn btn-sm btn-light-primary"
                    >
                      {{ $t('companyProfile.faliyytSahsiniSein') }}
                    </button>
                  </div>

                  <hr v-if="selectedSectors.length>0">
                  <SelectedSectorView
                    :sectors="selectedSectors"
                    :parent-id="0"
                  />

                  <span>
                    {{ $t('personalCompanyActivate.maksimum5FaliyytSahsiSeBilrsiniz') }}
                  </span>
                </div>

                <div class="mb-3">
                  <button
                    type="submit"
                    class="btn btn-primary"
                  >
                    {{ $t('personalCompanyActivate.frdiProfiliAktivldir') }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-xl-4 ">
          <div class="card">
            <div class="card-body">
              <h4>
                {{ $t('personalCompanyActivate.irktLavEt') }}
              </h4>
              <hr>
              <p>
                {{ $t('personalCompanyActivate.frdiXsProfilininSlahiyytlriMhduddurFunksiyalardanD') }}
              </p>

              <p>
                <router-link
                  class="btn btn-primary btn-sm"
                  :to="{'name': 'companySearch'}"
                >
                  {{ $t('personalCompanyActivate.irktLavEt') }}
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-selection="5"
        :parent-sector="null"
        :selected="selectedSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {createPersonalCompany,} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getPhoto, getProfileName} from "@/repositories/Utils";

import SelectedSectorView from "@/components/SelectedSectorsView.vue";

export default {
  components: {SelectedSectorView,},
  data() {
    return {
      mediaBase: mediaBase,
      selectedProfile: null,
      profiles: this.$t('profileNames'),
      selectedSectors: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  watch: {
    user(val) {
      if (val?.personalCompanyCreated) {
        this.$router.push({name: 'changeAccount'});
      }
    }
  },
  mounted() {
    if (this.user?.personalCompanyCreated) {
      this.$router.push({name: 'changeAccount'});
    }
  },
  methods: {
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    sectorSelected(sectors) {
      this.selectedSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createCompany() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      if (this.selectedSectors.length === 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("flyytShsSclmb"),
          icon: 'warning'
        })
        return;
      }

      createPersonalCompany(this.token, this.profiles[this.selectedProfile], this.selectedProfile, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("frdSxsHsbnzAktv"),
            icon: 'success'
          }).then(() => {
            this.$router.replace({name: 'changeAccount'});
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
